<template>
  <div class="flex-column">{{$t('second.text')}}</div>
</template>

<script>
export default {
  name: "Second",
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
